import { render, staticRenderFns } from "./AuthLoader.vue?vue&type=template&id=259473d4&scoped=true&"
import script from "./AuthLoader.vue?vue&type=script&lang=js&"
export * from "./AuthLoader.vue?vue&type=script&lang=js&"
import style0 from "./AuthLoader.vue?vue&type=style&index=0&id=259473d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259473d4",
  null
  
)

export default component.exports